import { gql } from "apollo-boost"

export const DASHBOARD_PROJECT = gql`
    query DashboardProject ($id: ID!){
        DashboardProject (id: $id) {
            id
            name
            approved
            status
            concepts {
                region
            }
            budgeted
            region
            startDate
            endDate
            evidenced
            implementer {
                id
                name
            }
            invoices {
                id
                createdAt
                ficosecPayment
            }
            beneficiaries {
                id
                number
            }
        }
    }
`
